import { render, staticRenderFns } from "./RaizDeNovidades.vue?vue&type=template&id=f6f3cf34&"
import script from "./RaizDeNovidades.vue?vue&type=script&lang=ts&"
export * from "./RaizDeNovidades.vue?vue&type=script&lang=ts&"
import style0 from "./novidades.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports